import React, { useEffect, useRef, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

const SUGGESTIONS = [
  "How can I improve my knee bend?",
  "What should I focus on first?",
  "Give me one drill for my next session.",
];

export default function ServeCoachChat({ videoId }) {
  const [user, setUser] = useState(null);
  const [messages, setMessages] = useState([{ role: "coach", text: "I have your serve data ready. What would you like to improve?" }]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const messagesRef = useRef(null);

  useEffect(() => onAuthStateChanged(auth, setUser), []);
  useEffect(() => {
    messagesRef.current?.scrollTo({ top: messagesRef.current.scrollHeight, behavior: "smooth" });
  }, [messages, sending]);

  async function sendMessage(question = input) {
    const trimmedQuestion = question.trim();
    if (!trimmedQuestion || sending) return;

    const newMessages = [...messages, { role: "user", text: trimmedQuestion }];
    setMessages(newMessages);
    setInput("");
    setSending(true);

    try {
      if (!user) throw new Error("Please sign in before asking your coach.");
      const response = await fetch("/api/ask-serve-coach", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${await user.getIdToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ question: trimmedQuestion, videoId }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "The coach could not answer right now.");
      setMessages([...newMessages, { role: "coach", text: data.answer }]);
    } catch (error) {
      setMessages([...newMessages, { role: "coach", text: error.message }]);
    } finally {
      setSending(false);
    }
  }

  return (
    <section className="coach-chat">
      <div className="coach-suggestions">
        {SUGGESTIONS.map((suggestion) => <button key={suggestion} type="button" onClick={() => sendMessage(suggestion)} disabled={sending}>{suggestion}</button>)}
      </div>
      <div className="coach-messages" ref={messagesRef} aria-live="polite">
        {messages.map((message, index) => (
          <article className={`coach-message ${message.role}`} key={`${message.role}-${index}`}>
            <span>{message.role === "user" ? "You" : "Evolve Sports Coach"}</span>
            <p>{message.text}</p>
          </article>
        ))}
        {sending ? <article className="coach-message coach"><span>Evolve Sports Coach</span><p>Reviewing your serve data…</p></article> : null}
      </div>
      <form className="coach-composer" onSubmit={(event) => { event.preventDefault(); sendMessage(); }}>
        <input value={input} onChange={(event) => setInput(event.target.value)} placeholder="Ask about your serve…" maxLength="500" disabled={sending} />
        <button className="button button-primary" type="submit" disabled={!input.trim() || sending}>Ask coach</button>
      </form>
    </section>
  );
}
